export default "__VITE_ASSET__JHweaGuT__"